import { render, staticRenderFns } from "./AdminAddRoleComponent.vue?vue&type=template&id=5509f3c2&"
import script from "./AdminAddRoleComponent.vue?vue&type=script&lang=js&"
export * from "./AdminAddRoleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports